import { AxiosRequestConfig } from 'axios';

/** The header the backend reads the organization context from. */
export const ORGANIZATION_HEADER = 'x-organization-id';

/**
 * Options for every warehouse API call (review S3). The organization of the
 * query key, or of the submitting form, travels on the request itself: the
 * shared client reads the selected organization only after an async token
 * refresh, so a switch in between would otherwise answer one organization's
 * key with another's data. `signal` lets TanStack Query cancel a superseded
 * fetch. Pass the result as the generated method's `options` argument.
 */
export function warehouseRequestOptions(
  organizationId: string,
  signal?: AbortSignal,
): AxiosRequestConfig {
  return {
    headers: { [ORGANIZATION_HEADER]: organizationId },
    ...(signal ? { signal } : {}),
  };
}

/** Warehouse requests never fall back to "whatever is selected at send time". */
export function requireOrganizationId(organizationId?: string): string {
  if (!organizationId) {
    throw new Error('Warehouse request without a selected organization');
  }
  return organizationId;
}
